var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-loading is-fullheight has-loader primary-loader app-container w-100 is-size-1"})}
var staticRenderFns = []

export { render, staticRenderFns }